export default (function (_ref) {
  var service = _ref.service,
      request = _ref.request,
      serviceForMock = _ref.serviceForMock,
      requestForMock = _ref.requestForMock,
      mock = _ref.mock,
      faker = _ref.faker,
      tools = _ref.tools;
  return {
    /**
     * 轮播图
     */
    // 顶部轮播
    topBanners: function topBanners() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: 'top-banners',
        method: 'get',
        data: data
      });
    },
    // 删除轮播图
    deletetopBanner: function deletetopBanner() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: 'delete-top-banner',
        method: 'post',
        data: data
      });
    },
    // 添加轮播图
    addTopBanner: function addTopBanner() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: 'add-top-banner',
        method: 'post',
        data: data
      });
    },
    // 修改轮播图
    updTopBanner: function updTopBanner() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: 'update-top-banner',
        method: 'post',
        data: data
      });
    },

    /**
     * 游戏类型
     */
    // 游戏类型列表
    gameType: function gameType() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: 'game-types',
        method: 'get',
        data: data
      });
    },
    // 删除游戏类型
    delGameType: function delGameType() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: 'delete-game-type',
        method: 'post',
        data: data
      });
    },
    // 新增游戏类型
    addGameType: function addGameType() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: 'add-game-type',
        method: 'post',
        data: data
      });
    },
    // 修改游戏类型
    updGameType: function updGameType() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: 'update-game-type',
        method: 'post',
        data: data
      });
    },

    /**
     * 游戏列表
     */
    // 获取游戏列表
    gameList: function gameList() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: 'games',
        method: 'get',
        data: data
      });
    },
    // 新增游戏
    addGame: function addGame() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: 'add-game',
        method: 'post',
        data: data
      });
    },
    // 修改游戏
    updGame: function updGame() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: 'update-game',
        method: 'post',
        data: data
      });
    },
    // 删除游戏
    delGame: function delGame() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: 'delete-game',
        method: 'post',
        data: data
      });
    },

    /**
     * 游戏视频
     */
    // 视频列表
    gameVideo: function gameVideo() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: 'game-videos',
        method: 'get',
        data: data
      });
    },
    // 新增游戏视频
    addGameVideo: function addGameVideo() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: 'add-game-video',
        method: 'post',
        data: data
      });
    },
    // 修改游戏视频
    updGameVideo: function updGameVideo() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: 'update-game-video',
        method: 'post',
        data: data
      });
    },
    // 删除游戏视频
    delGameVideo: function delGameVideo() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: 'delete-game-video',
        method: 'post',
        data: data
      });
    },

    /**
     * 公告类型
     */
    // 公告类型列表
    AnnounceTypes: function AnnounceTypes() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: 'get-announce-types',
        method: 'get',
        data: data
      });
    },
    // 新增公告类型
    addAnnounceType: function addAnnounceType() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: 'add-announce-type',
        method: 'post',
        data: data
      });
    },
    // 修改公告类型
    updAnnounceType: function updAnnounceType() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: 'update-announce-type',
        method: 'post',
        data: data
      });
    },
    // 删除公告类型
    delAnnounceType: function delAnnounceType() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: 'delete-announce-type',
        method: 'post',
        data: data
      });
    },
    // 获取所有公告类型
    announceTypeList: function announceTypeList() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: 'get-announce-type-id-name-map',
        method: 'get',
        data: data
      });
    },

    /**
     * 公告列表
     */
    // 公告列表
    Announce: function Announce() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: 'get-announces',
        method: 'get',
        data: data
      });
    },
    // 新增公告
    addAnnounce: function addAnnounce() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: 'add-announce',
        method: 'post',
        data: data
      });
    },
    // 修改公告
    updAnnounce: function updAnnounce() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: 'update-announce',
        method: 'post',
        data: data
      });
    },
    // 删除公告
    delAnnounce: function delAnnounce() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: 'delete-announce',
        method: 'post',
        data: data
      });
    },
    // 轮播图
    bannerData: function bannerData() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: 'bannerData',
        method: 'get',
        data: data
      });
    },
    // 新增公告
    bannnerAdd: function bannnerAdd() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: 'bannnerAdd',
        method: 'post',
        data: data
      });
    },
    // 修改公告
    bannerUpdate: function bannerUpdate() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: 'bannerUpdate',
        method: 'post',
        data: data
      });
    },
    // 删除公告
    bannerDel: function bannerDel() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: 'bannerDel',
        method: 'post',
        data: data
      });
    },
    // 轮播图排序
    bannerChangeSort: function bannerChangeSort() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: 'bannerChangeSort',
        method: 'post',
        data: data
      });
    },
    // 社交渠道
    socialData: function socialData() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: 'socialData',
        method: 'get',
        data: data
      });
    },
    // 新增社交渠道
    socialAdd: function socialAdd() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: 'socialAdd',
        method: 'post',
        data: data
      });
    },
    // 修改社交渠道
    socialUpdate: function socialUpdate() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: 'socialUpdate',
        method: 'post',
        data: data
      });
    },
    // 删除社交渠道
    socialDel: function socialDel() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: 'socialDel',
        method: 'post',
        data: data
      });
    },
    // 渠道排序
    socialChangeSort: function socialChangeSort() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: 'socialChangeSort',
        method: 'post',
        data: data
      });
    },
    // 下载地址配置
    downLoadData: function downLoadData() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: 'downLoadData',
        method: 'get',
        data: data
      });
    },
    // 新增社交渠道
    downLoadLinkAdd: function downLoadLinkAdd() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: 'downLoadLinkAdd',
        method: 'post',
        data: data
      });
    },
    // 修改社交渠道
    downloadLinkUpdate: function downloadLinkUpdate() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: 'downloadLinkUpdate',
        method: 'post',
        data: data
      });
    },
    // 删除社交渠道
    downloadLinkDel: function downloadLinkDel() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: 'downloadLinkDel',
        method: 'post',
        data: data
      });
    },
    // 社交渠道排序
    downloadLinkChangeSort: function downloadLinkChangeSort() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: 'downloadLinkChangeSort',
        method: 'post',
        data: data
      });
    },
    //  人物轮播列表
    roleBannerData: function roleBannerData() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: 'roleBannerData',
        method: 'get',
        data: data
      });
    },
    //  人物轮播新增
    roleBannnerAdd: function roleBannnerAdd() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: 'roleBannnerAdd',
        method: 'post',
        data: data
      });
    },
    //  人物轮播修改
    roleBannerUpdate: function roleBannerUpdate() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: 'roleBannerUpdate',
        method: 'post',
        data: data
      });
    },
    //  人物轮播删除
    roleBannerDel: function roleBannerDel() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: 'roleBannerDel',
        method: 'post',
        data: data
      });
    },
    //  人物轮播排序
    roleBannerChangeSort: function roleBannerChangeSort() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: 'roleBannerChangeSort',
        method: 'post',
        data: data
      });
    },
    // 宗门弟子
    //  列表
    heroSlideshowData: function heroSlideshowData() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: 'heroSlideshowData',
        method: 'get',
        data: data
      });
    },
    //  新增
    heroSlideshowAdd: function heroSlideshowAdd() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: 'heroSlideshowAdd',
        method: 'post',
        data: data
      });
    },
    //  修改
    heroSlideshowUpdate: function heroSlideshowUpdate() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: 'heroSlideshowUpdate',
        method: 'post',
        data: data
      });
    },
    //  删除
    heroSlideshowDel: function heroSlideshowDel() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: 'heroSlideshowDel',
        method: 'post',
        data: data
      });
    },
    //  排序
    heroSlideshowChangeSort: function heroSlideshowChangeSort() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: 'heroSlideshowChangeSort',
        method: 'post',
        data: data
      });
    },
    offWebPkgConfigIndex: function offWebPkgConfigIndex() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: 'offWebPkgConfigIndex',
        method: 'get',
        data: data
      });
    },
    offWebPkgConfigDestroy: function offWebPkgConfigDestroy() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: 'offWebPkgConfigDestroy',
        method: 'post',
        data: data
      });
    },
    offWebPkgConfigAdd: function offWebPkgConfigAdd() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: 'offWebPkgConfigAdd',
        method: 'post',
        data: data
      });
    },
    offWebPkgConfigUpdate: function offWebPkgConfigUpdate() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: 'offWebPkgConfigUpdate',
        method: 'post',
        data: data
      });
    }
  };
});